import React, { Fragment } from 'react';
import skyportmap from '../../../../../images/skyportmap.png';
import skyport1 from '../../../../../images/skyport1.jpg';

const SkyportParked = () => (
  <Fragment>
    <p>
      Autzu vehicles are parked on the 3rd Floor of the Skyport Parking
      facility at 2430 FDR Drive Service Rd E, New York, NY 10010.
    </p>
    <img
      className="faq-image-compress faq-image-width faq-image-padding"
      src={skyport1}
      alt="skportmap"
    />

    <img
      className="faq-image-compress faq-image-width faq-image-padding"
      src={skyportmap}
      alt="skportmap"
    />
    <br />
    <p>This location is easily accessible by public transport:</p>
    <p>
      <b>Line L</b> - 13 minute walk
    </p>
    <p>
      <b>Lines 4 6</b> - 15 minute walk
    </p>
    <p>
      <b>Lines N Q R Q</b> - 23 minute walk
    </p>
    <p>
      We also provide <b>free parking</b> for those who drive a personal
      vehicle to our location.
    </p>
  </Fragment>
);

export default SkyportParked;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingLotData/Skyport/SkyportParked.js